import { Head } from "@inertiajs/react";
import { useState } from "react";

const BC = { fontFamily: "'Oswald', sans-serif" } as const;

const METHODS = [
  {
    num: "01",
    title: "Email From Your Track Domain",
    body: "Send us an email from a work address at the domain of the track you manage (e.g. you@yourtrack.com). If you don't have a domain email set up yet, include a link to the track's website that shows your name or role.",
  },
  {
    num: "02",
    title: "Message From an Official Social Account",
    body: "DM us from the official Instagram, Facebook, or TikTok page of the track or event. A quick \"hey, my Driftables account is [your email]\" is all we need.",
  },
  {
    num: "03",
    title: "Link to a Public Listing",
    body: "Share a link to any public page — track website, Facebook event, flyer, or social post — where you're named as an organizer, owner, or staff member. Screenshot works too if the original is gone.",
  },
] as const;

export default function Verification() {
  const [revealed, setRevealed] = useState(false);
  const f = "james"
  const m = "ms"
  const l = "kelsey"
  const mt = ['m','a','i','l','t','o']

  return (
    <>
      <Head title="Verify Your Identity — Driftables" />

      <div className="min-h-screen" style={{ background: "#0b0b0b" }}>
        <div className="max-w-[760px] mx-auto px-6 md:px-10 pt-16 pb-24">

          {/* Header */}
          <p
            className="text-[#ff2e89] text-[0.72rem] font-bold tracking-[0.32em] uppercase mb-4"
            style={BC}
          >
            Event Host Verification
          </p>
          <h1
            className="text-[#f0ece8] font-black uppercase leading-none mb-6"
            style={{ ...BC, fontSize: "clamp(2.4rem, 6vw, 4rem)" }}
          >
            How to Verify<br />Yourself
          </h1>
          <p className="text-[#888] text-[1rem] leading-[1.75] mb-10 max-w-[52ch]">
            We verify event hosts manually — it keeps spam and fake events off the platform.
            Once you're verified you'll get full access to create and manage events on Driftables.
            The process is quick; most people hear back within a day.
          </p>

          {/* Email CTA */}
          <div
            className="border border-[#242424] p-8 mb-14 relative overflow-hidden"
            style={{ background: "#141414" }}
          >
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#ff2e89]" />
            <p
              className="text-[#f0ece8] text-[1.1rem] font-bold uppercase tracking-wide mb-2"
              style={BC}
            >
              Email us to start the process
            </p>
            <p className="text-gray-100 text-sm leading-relaxed mb-6">
              Drop us a line and we'll reply with next steps. Include your Driftables
              account email and which track or club you run.
            </p>
            {revealed ? (
              <a
                href={`${mt.join('')}:${f + m + l}@gmail.com?subject=Driftables%20verification`}
                className="inline-block no-underline uppercase text-sm font-bold tracking-widest bg-[#ff2e89] text-[#0b0b0b] px-6 py-3 hover:opacity-80 transition-opacity"
                style={BC}
              >
                {f + m + l}@gmail.com
              </a>
            ) : (
              <button
                type="button"
                onClick={() => setRevealed(true)}
                className="uppercase text-sm font-bold tracking-widest bg-[#ff2e89] text-[#0b0b0b] px-6 py-3 hover:opacity-80 transition-opacity cursor-pointer border-0"
                style={BC}
              >
                Reveal Email Address
              </button>
            )}
          </div>

          {/* Verification methods */}
          <p
            className="text-[#ff2e89] text-[0.72rem] font-bold tracking-[0.32em] uppercase mb-6"
            style={BC}
          >
            Ways we verify you
          </p>
          <div className="flex flex-col gap-[3px]">
            {METHODS.map(({ num, title, body }) => (
              <div
                key={num}
                className="border border-[#242424] p-7 flex gap-6"
                style={{ background: "#141414" }}
              >
                <span
                  className="text-transparent shrink-0 leading-none select-none"
                  style={{
                    ...BC,
                    fontSize: "2.8rem",
                    fontWeight: 900,
                    WebkitTextStroke: "1px rgba(255,46,137,0.22)",
                  }}
                >
                  {num}
                </span>
                <div>
                  <h3
                    className="text-[#f0ece8] font-bold uppercase tracking-wide text-[1rem] mb-2"
                    style={BC}
                  >
                    {title}
                  </h3>
                  <p className="text-[#777] text-sm leading-[1.7]">{body}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="text-[#555] text-sm mt-10 leading-relaxed">
            Only one of the above is needed — use whichever is easiest for you.
            If none of these work for your situation, just explain in your email and we'll figure it out.
          </p>
        </div>
      </div>
    </>
  );
}
